export default {
    title: '訂單完成'
}
